//imports
import {
    SMS_SYSTEM_CREATE_EDIT_OPEN_MODAL,
    SMS_SYSTEM_CREATE_REQUEST,
    SMS_SYSTEM_CREATE_RESULT,
    SMS_SYSTEM_EDIT_REQUEST,
    SMS_SYSTEM_EDIT_RESULT,
    SMS_SYSTEM_GET_REQUEST,
    SMS_SYSTEM_GET_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    smsSystem: null,
    current: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SMS_SYSTEM_GET_REQUEST:
            return { ...state, loading: true }

        case SMS_SYSTEM_GET_RESULT:
            return { ...state, loading: false, smsSystem: action.payload }

        case SMS_SYSTEM_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, current: action.payload.data }

        case SMS_SYSTEM_CREATE_REQUEST:
            return { ...state, loading: true }

        case SMS_SYSTEM_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case SMS_SYSTEM_EDIT_REQUEST:
            return { ...state, loading: true }

        case SMS_SYSTEM_EDIT_RESULT:
            return { ...state, loading: false, update: action.payload }

        case CLEAR_REDUX:
            return ["", "SMS_SYSTEM_CREATE_EDIT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};